import { render, staticRenderFns } from "./EfasRegistrationProfile.vue?vue&type=template&id=3dc03e40&scoped=true&"
import script from "./EfasRegistrationProfile.vue?vue&type=script&lang=js&"
export * from "./EfasRegistrationProfile.vue?vue&type=script&lang=js&"
import style0 from "./EfasRegistrationProfile.vue?vue&type=style&index=0&id=3dc03e40&prod&scoped=true&lang=css&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "3dc03e40",
  null
  
)

export default component.exports